<template>
    <div class="qrcode">
        <div class="android qrcode-width">
            <img src="../assets/img/android.png" title="android">
            <button class="downloadBtn">Android下载</button>
        </div>
        <div class="ios qrcode-width">
            <img src="../assets/img/ios.png">
            <button class="downloadBtn" title="ios">ios下载</button>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return {

    }
  }
}
</script>

<style lang="less" scoped>
    .qrcode {
        position: fixed;
        right: 14%;
        bottom: 9%;
        width: 600px;
        display: flex;
        justify-content:  space-evenly;
        align-items: center;

        .qrcode-width{
            display: flex;
            flex-direction: column;
            align-items:center;
            margin: 0 10px;

            img {
                width: 150px;
                height: 150px;
            }

            .downloadBtn {
                width: 120px;
                height: 35px;
                color: #fff;
                background-color: rgba(29, 109, 247, 1);
                border: 0;
                margin-top: 5px;
            }
        }
    }
</style>